import { useEffect, useState } from 'react';
import { Routes as RouterRoutes, Route, useLocation } from 'react-router-dom';
import MainComponent from './components/main';
import ContactPage from './components/ContactPage';
import LogoSplash from './components/LogoSplash';

function ScrollToSection() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    const pathToSection = {
      '/': '#home',
      '/services': '#services',
      '/calculator': '#calculator',
      '/about': '#about',
    };

    const targetSelector = hash || pathToSection[pathname];
    if (!targetSelector) return;

    const scroll = () => {
      const target = document.querySelector(targetSelector);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const timer = window.setTimeout(scroll, 0);
    return () => window.clearTimeout(timer);
  }, [hash, pathname]);

  return null;
}

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowSplash(false), 1400);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      <LogoSplash show={showSplash} />
      <ScrollToSection />
      <RouterRoutes>
        <Route path="/kontakt" element={<ContactPage />} />
        <Route path="/services" element={<MainComponent />} />
        <Route path="/calculator" element={<MainComponent />} />
        <Route path="/about" element={<MainComponent />} />
        <Route path="/" element={<MainComponent />} />
        <Route path="/*" element={<MainComponent />} />
      </RouterRoutes>
    </div>
  );
}

export default App;
